import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rtl } from '../../utils/language';
import Close from '../common/Icons/Close';
import { getFileTypeIcon } from '../common/FileUpload/helpers';
import { useFileTypes } from '../common/FileUpload/useFileTypes';
import AttachmentRemovePrompt from './AttachmentRemovePrompt';

const FileWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  border-radius: 6px;
  border: solid 2px #e9e9e9;
  background-color: #ffffff;
  padding: 10px 20px;
  cursor: inherit;
`;

const Filename = styled.div`
  font-size: 14px;
  margin: 0px 20px;
`;

const CloseButton = styled.button`
  margin-left: auto;

  ${rtl`
      margin-left: 0;
      margin-right: auto;
  `};
  display: flex;
  align-items: center;
  background: none;
  padding: 0;
`;

const AttachedFile = ({ attachment, removeAttachment }) => {
  const { getFileType } = useFileTypes(
    window.AssignmentAppConfig.fileService.ASSIGNMENT_CREATION_ATTACHMENT,
  );

  const fileType = getFileType({ name: attachment.fileName });
  const [shouldShowRemovePrompt, setRemovePrompt] = useState(false);

  if (!fileType) return null;
  const FileTypeIcon = getFileTypeIcon(fileType);

  const toggleRemovePrompt = () => {
    setRemovePrompt(false);
  };

  return (
    <>
      <FileWrapper>
        <FileTypeIcon size={40} />
        <Filename
          data-testid="uploaded-file"
          data-filehash={`${attachment.fileUuid}`}
        >
          {attachment.name || attachment.fileName}
        </Filename>
        <CloseButton
          data-testid="uploader-remove-button"
          onClick={() => {
            setRemovePrompt(true);
          }}
        >
          <Close color="#485465" />
        </CloseButton>
      </FileWrapper>
      {shouldShowRemovePrompt && (
        <AttachmentRemovePrompt
          toggleModal={toggleRemovePrompt}
          onConfirm={() => {
            toggleRemovePrompt();
            removeAttachment();
          }}
        />
      )}
    </>
  );
};

AttachedFile.propTypes = {
  attachment: PropTypes.object.isRequired,
  removeAttachment: PropTypes.func.isRequired,
};

export default AttachedFile;
